import React from 'react';
import { Settings, GripVertical, Eye, EyeOff, RotateCcw } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';
import { Switch } from './ui/switch';

const widgetNames = {
  'plan': 'Piano Abbonamento',
  'stats': 'Statistiche Principali',
  'alerts': 'Avvisi e Scadenze',
  'recent-events': 'Prossimi Eventi',
  'quick-actions': 'Azioni Rapide',
  'recent-activities': 'Attività Recenti',
  'soci-stats': 'Statistiche Soci'
};

const widgetDescriptions = {
  'plan': 'Mostra il piano attuale e i limiti di utilizzo',
  'stats': 'Volontari, eventi, ore e presenze',
  'alerts': 'Coperture in scadenza e promemoria',
  'recent-events': 'Lista dei prossimi eventi programmati',
  'quick-actions': 'Pulsanti per azioni frequenti',
  'recent-activities': 'Ultime attività registrate',
  'soci-stats': 'Statistiche sui soci e quote'
};

export default function DashboardConfigDialog({ 
  open, 
  onOpenChange, 
  config, 
  toggleWidget, 
  reorderWidgets,
  resetConfig 
}) {
  const moveWidget = (index, direction) => {
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    if (newIndex >= 0 && newIndex < config.widgets.length) {
      reorderWidgets(index, newIndex);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Personalizza Dashboard
          </DialogTitle>
          <DialogDescription>
            Scegli quali widget visualizzare e in quale ordine
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4 space-y-3 max-h-[400px] overflow-y-auto">
          {config.widgets
            .sort((a, b) => a.order - b.order)
            .map((widget, index) => (
              <div 
                key={widget.id}
                className={`flex items-center gap-3 p-3 rounded-lg border transition-colors ${
                  widget.enabled ? 'bg-white border-gray-200' : 'bg-gray-50 border-gray-100'
                }`}
              >
                {/* Drag handle placeholder */}
                <div className="flex flex-col gap-0.5">
                  <button
                    onClick={() => moveWidget(index, 'up')}
                    disabled={index === 0}
                    className="p-0.5 hover:bg-gray-100 rounded disabled:opacity-30 disabled:cursor-not-allowed"
                  >
                    <svg className="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  </button>
                  <button
                    onClick={() => moveWidget(index, 'down')}
                    disabled={index === config.widgets.length - 1}
                    className="p-0.5 hover:bg-gray-100 rounded disabled:opacity-30 disabled:cursor-not-allowed"
                  >
                    <svg className="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                </div>
                
                <div className="flex-1 min-w-0">
                  <p className={`font-medium ${widget.enabled ? 'text-gray-900' : 'text-gray-400'}`}>
                    {widgetNames[widget.id] || widget.id}
                  </p>
                  <p className="text-xs text-gray-500 truncate">
                    {widgetDescriptions[widget.id]}
                  </p>
                </div>
                
                <Switch
                  checked={widget.enabled}
                  onCheckedChange={() => toggleWidget(widget.id)}
                />
              </div>
            ))}
        </div>
        
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button 
            variant="outline" 
            onClick={resetConfig}
            className="w-full sm:w-auto"
          >
            <RotateCcw className="h-4 w-4 mr-2" />
            Ripristina Default
          </Button>
          <Button 
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
          >
            Fatto
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
